module.exports = __webpack_public_path__ + "static/media/become-a-guider.9be57a0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/become-a-guider.mp4
// module id = 6aAG
// module chunks = 1